import { meritalStatus, expenseCategory, singleMeritalStatus, familyProgramStatus, familyStatus, teamMembers, one2five,      
    needLegal, needSolutionEntity, employQuality, savingStatus, noYes, noYesPratial, noneYes, noYesOther, noYesWasInPast,
    noMaybeYes, yesConsiderNo, socialSection, rightsType, payPeriod, womanManBoth, femaleMale, maleFemaleOther, kidParents,    
    kidMisgeret, incomeType, houseOwner, debtsRange, lawner, notEmpWorkBefore,  employStatus, employSocial, academicEducation,
    secularEducation, notEmpWorkDuration,yearsOfStudy,
    kupatHolim, healthIssues, bltLevel, btlAck, bagroot, employNewBuisness, employVolunteer  } from '../../variables/ComboValues'
    //familyReferralStatus, one2seven, one2sixTEXT, one2six,
    //one2fiveTEXT, one2fiveQuality, one2fiveLevel, hard2easy, taskArrayStatus,leaveEmpty,onlyYes, yesHesitateNo, one2sevenB,    
    //oneTill4plus,  oneTill8, oneTill12plus, yearsOfStudy, snapshotOptions, snapshotExclude, taskStatus, years2015_2026,

const fieldMap = {
    mertial_status: meritalStatus,
    intake_yahav_member: teamMembers,
    program_status: familyProgramStatus,
    family_in_revaha: noYesWasInPast,
    family_revaha_intense: one2five,
    other_programs: noYesOther,
    family_debt_lawner: lawner,
    family_debt_returnontime: noYes,
    family_debt_arrangement: noneYes,
    family_debt_unify: noneYes,
    debts_range: debtsRange,
    debts_bankropt: yesConsiderNo,
    expense_category:expenseCategory,
    family_house: houseOwner,
    family_house_status: noYes,
    income_type: incomeType,
    income_goesto: womanManBoth,
    income_frequency: payPeriod,
    kid_gender: maleFemaleOther,
    kid_parents: kidParents,
    kid_misgeret: kidMisgeret,
    need_legal: needLegal,
    mortgage_last6: noYesPratial,
    family_status: familyStatus,
    rights_pay_type: rightsType,
    rights_frequency: payPeriod,
    rights_extent: one2five,
    rights_assistance: noMaybeYes,
    do_u_save: savingStatus,
    needsolution_role: needSolutionEntity,
    // paremts
    year_of_study: yearsOfStudy,
    bagroot: bagroot,
    academic_education: academicEducation,
    secular_education: secularEducation,
    employ_status: employStatus,
    employ_quality: employQuality,
    employ_social: employSocial,
    employ_i1: noYes,
    employ_i2: noYes,
    employ_i3: noYes,
    employ_i4: noYes,
    employ_i5: noYes,
    employ_new_buisness: employNewBuisness,
    employ_volunteer: employVolunteer,
    parent_gender: femaleMale,
    parent_merital_status: singleMeritalStatus,
    parent_social_section: socialSection,
    health_issue_limit: noYes,
    parent_health: healthIssues,
    parent_bituachleumi: bltLevel,
    parent_bituachleumi_temp: btlAck,
    parent_kupat_holim: kupatHolim,
    notemp_workbefore: notEmpWorkBefore,
    notemp_howlong: notEmpWorkDuration,
    notenough: noYes,
    noreview: noYes,
    nopass: noYes,
    nostay: noYes,

}
export const fieldTypeMap = (entity, tab, familyFieldList, parentFieldList, field) => {
    const list = (entity === 'משפחה') ? familyFieldList : parentFieldList
    let found= ""
    Object.entries(list).map( item => {
        if (item[1][0] === tab){
            let ttab = item[1][2]
            //  let elfound = Object.values(ttab).find(tt => field === tt[1]['label'])
            //  found = fieldMap(elfound[1]['name'])
            Object.entries(ttab).map(tt => {
                // console.log('fieldTypeMap loop tt.lable= '+ tt[1].label + '  field= '+ field)
                if (tt[1]['label'] === field){
                    found = fieldMap[tt[1]['name']]
                    //console.log(tt)
                }
                return null
            })
        }
        return null
    })
    //console.log('fieldTypeMap', found)
    return found
//    return expenseCategory
}
export const qb_whatAmI = (tab, field) =>{
    
    return fieldTypeMap[field]
}

